import React, { ButtonHTMLAttributes, FC, MouseEventHandler, useCallback, useState } from 'react';

import * as S from './styles';

export interface IButtonTeamPickerProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  teamColor: string;
}

const ButtonTeamPicker: FC<IButtonTeamPickerProps> = ({ teamColor, onClick, ...props }) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      setIsClicked(true);
      onClick && onClick(e);
    },
    [onClick],
  );

  return (
    <S.StyledButton
      disabled={isClicked}
      $bgColor={teamColor}
      {...props}
      onClick={handleClick}
    />
  );
};

export default ButtonTeamPicker;
